<template>
  <!-- eslint-disable -->
  <div class="container-fluid">
    <div class="row header">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <p class="dg-header-label">Brand</p>
        <h1 class="dg-header">Icons</h1>
        <vue-markdown :source="docs.docs"></vue-markdown>
      </div>
    </div>

    <div class="row content">
      <div class="col-lg-10 offset-lg-1 col-xl-8 offset-xl-2">
        <!-- Content -->
        <div class="row">
          <div class="col">
            
            <div class="row">
              <div class="col">
                <p class="h3 dg-subheader">A few Examples</p>   
              </div>
            </div>

            <ComponentExample>
              <template slot="ui-example">
                <div v-html="docs.usage.componentExample" />
              </template>
              <template slot="code-example">
{{docs.usage.componentExample}}
              </template>
              <template slot="link">
                <a href="https://codepen.io/emichigan/pen/XEEqzO" class="edit-link btn btn-primary btn-sm" target="_blank">Edit on Codepen</a>
              </template>
            </ComponentExample>            
          </div>
        </div>

        <ComponentDoc :docs="docs"></ComponentDoc>
  
        <div class="row mt-4">
          <div class="col">

            <div class="row">
              <div class="col">
                <p class="h3 dg-subheader">Library</p>
              </div>
            </div>

            <div id="somicons">
              <div class="row">
                <div class="col">
                  <input type="text" v-model='search' class="form-control form-control-lg my-3" placeholder="Search for icon" aria-label="Search for icon">
                </div>
              </div>
              <div class="row">
                <div class="col-6 col-sm-4 col-lg-3" v-for="(icon, index) in filteredIcons" :key="index">
                  <div class="card-deck icon-sample">
                    <div class="card md-4 mb-sm-3">
                      <div class="card-body text-center">
                        <som-icon v-bind:name="icon.icons[0]" size="lg"></som-icon>
                      </div>
                      <div class="card-footer text-center">
                        <p>{{icon.icons[0]}}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
        <!-- Content End -->
      </div>
    </div>  
  </div>
  <!-- eslint-enable -->
</template>

<script>
import axios from 'axios';
import VueMarkdown from 'vue-markdown';
import ComponentExample from "../ComponentExample";
import ComponentDoc from "../ComponentDoc";
import Docs from '../../../static/docs.json';

export default {
  name: "Icons",
  components: {
    VueMarkdown,
    ComponentExample,
    ComponentDoc
  },
  data() {
    return {
      search: "",
      icons: [],
      docs: Docs.components.find(component => component.tag === 'som-icon')
    };
  },
  created() {
    const self = this;
    const url = (process.env.NODE_ENV === "development" ? "https://digitalguidelines.michigan.gov" : ".") + "/cdn/latest/som-components/data.json";
    axios.get(url)
      .then((response)  =>  {
        self.icons = response.data.icons;
      }, (error)  =>  {
        console.log('Error Loading Icons', error);
      })
  },

  computed: {
    filteredIcons() {
      const q = this.search.toLowerCase();
      return this.icons.filter(
        icon => icon.icons[0].toLowerCase().indexOf(q) !== -1
      );
    }
  }
};
</script>

/* esling-disable */
<style lang="sass?outputStyle=expanded">
@import '../../assets/scss/variables';
.icon-sample {
  margin-top: 2rem;
  flex-flow: row wrap;
  margin-right: -15px;
  margin-left: -15px;
  @media (max-width: 575.98px) {
    margin-bottom: 5rem;
  }
  @media (min-width: 992px) {
    column-count: 4;
  }
  @media (min-width: 1200px) {
    column-count: 5;
  }
  .card{
    cursor: pointer;
    flex: 1 0 0%;
    margin-left: 15px;
    margin-right: 15px;
    .card-body{
      padding: 2rem 1.25rem;
    }
    .card-footer{
      p{
        margin-bottom: 0;
        padding: 1rem;
        line-height: 1.2;
        font-size: .8rem;
      }
    }
    &:hover{
      .card-body{
        background: $gray-100;
      }
      .card-footer{
        background: $white;
      }
      svg {
        fill: $primary !important; }
    }
  }
}
</style>
/* eslint-enable */



// WEBPACK FOOTER //
// src/components/routes/Icons.vue